
import { Component, Output, ViewChild, OnDestroy, ElementRef, EventEmitter, } from '@angular/core';
import { UsersService } from '../_services/users.service';
import { Router, ActivatedRoute, Event, ActivationEnd, NavigationEnd} from '@angular/router';
import { IuserInformation } from '../_types/userInterfaces.type';
import { ComponentRefService } from '../_services/componentRef.service';
import { NgxPermissionsService} from 'ngx-permissions';
import { Location } from '@angular/common';
import { WellsACLComponent } from '../acl/wells/wellsACL.component';  //*commented out or init commit david
import { FieldsACLComponent } from '../acl/fields/fieldsACL.component';  //*commented out or init commit david
import { ReportsACLComponent } from '../acl/reports/reportsACL.component';   //*commented out or init commit david
import { FieldsExpendituresACLComponent } from '../acl/fieldsexpenditures/fieldsexpendituresACL.component';
import { SharedFunctionsService } from '../_services/sharedFunctions.service';
import { UserProfileService } from '../../_services/user-profile.service';
import { UserProfile } from '../../_models/user-profile';
import { ManualPasswordResetModalComponent } from '../modals/manualPasswordReset/manualPasswordResetModal.component';
import { UntypedFormGroup, UntypedFormBuilder, Validators } from '@angular/forms';
import { SelectItem } from 'primeng/api';
declare let $: any;


@Component({
  selector: 'singleuser',
  templateUrl: './singleuser.component.html',
  styleUrls: ['./singleuser.component.css']
})

export class SingleUserComponent implements OnDestroy {
  public userProfile: IuserInformation = <IuserInformation>{};
  public userProfile2: IuserInformation = <IuserInformation>{};
  private loginUsername: string;
  public groupLoading: boolean = false;
  public search:string = ""
  public avaCompanyGroups: avaCompanyGroups[] = [];
  public ownedCompanyGroups: avaCompanyGroups[] = [];
  public saveChangesAlertClass: string = "alert";
  public profileMessage: string = "";
  public hasChanges: boolean = false;
  public groupsAlreadyAssoc: avaCompanyGroups[] = [];
  private company: string = "";
  public loadingGroups: boolean = true;
  public submitted: boolean = false;
  public manualPasswordAlertClass: string = "";
  public manualPasswordReset: string = "";
  public cloneUserName: string = "";
  public mode: state = state.editMode;
  public singleUserFrm: UntypedFormGroup;
  public groupActiveChangeCount: number = 0;
  public rePassword: string | null = "";
  public passwordType: string = "text";
  public ProAccess: boolean = false;
  public CPAccess: boolean = false;
  public showManualReset: boolean = false;
  public showFirstTime: boolean = false;
  public isLoading: boolean = false;
  public createUserMessage: string = "";
  public hasCPAccess: boolean | null;
  public tabsArray: Array<string> = []
  public up: UserProfile;
  public currentUserSeen: any;
  public dummbyValue1: any = new Date();
  public dummbyValue2: any = new Date();
  private _routerSub: any;
  private _initUsername: string = null;
  public Q_AVisible: boolean = false;
  public allCompanyUsers: IuserInformation[] = [];
  public userSelectOptions: SelectItem[] = [];
  public userSelect: SelectItem;
  public loadingAllUsers: boolean = false;
 
  @ViewChild(ManualPasswordResetModalComponent, { static: false }) passwordModalChild: ManualPasswordResetModalComponent;
  @ViewChild(WellsACLComponent, { static: false }) wellsACLChild: WellsACLComponent;  //*commented out or init commit david
  @ViewChild(FieldsACLComponent, { static: false }) fieldsACLChild: FieldsACLComponent;  //*commented out or init commit david
  @ViewChild(ReportsACLComponent, { static: false }) reportsACLChild: ReportsACLComponent;  //*commented out or init commit david
  @ViewChild(FieldsExpendituresACLComponent, { static: false }) fieldExpendituresACLChild: FieldsExpendituresACLComponent;  //*commented out or init commit david

  public sortArrayObjAva = {
    groupName: true
  }
  public sortArrayObjOwned = {
    groupName: true
  }
  @Output() someEvent = new EventEmitter<string>();
  constructor(private UserService: UsersService, private router: Router, private permissionsService: NgxPermissionsService, public ele: ElementRef, public location: Location, private fb: UntypedFormBuilder, private CompRefService: ComponentRefService, private sharedFunction: SharedFunctionsService,
    private ups: UserProfileService, private activatedRoute: ActivatedRoute) {
     this.ups.userProfile$.subscribe(result => {
       this.up = result;
     });
    this.singleUserFrm = this.fb.group({
      'fullname': "",
      'username': ["", Validators.compose([this.usernameValidator])],
      'email': ['', Validators.compose([this.emailValidator])],
      'passwordQuestion': "Q",
      'passwordAnswer': "A",
      'comment': "",
      'password': ["", Validators.compose([this.passwordValidator.bind(this)])],
      'rePassword': ["", Validators.compose([this.passwordValidator.bind(this)])],
      'firsttime': false,
      'hasPortalAccess': false,
      'isApproved': false
    });
    this.prepareClearUser()
    this.CompRefService.singleuser = this;
    this._routerSub = this.router.events.subscribe((event: any) => {
      if (event instanceof ActivationEnd || event.routerEvent instanceof NavigationEnd) {
        if (this.router.url.indexOf("ControlPanel/users/user/") != -1) {
          if (null == this._initUsername || this.activatedRoute.snapshot.params.username != this._initUsername)
            this.onInit();
        }
      }
    })

  }


  onInit() {
    if (typeof window != 'undefined') {
      this.isLoading = true;
      let usernameParam = this.activatedRoute.snapshot.params.username;
      if (null != usernameParam && typeof usernameParam != 'undefined') {
        this._initUsername = usernameParam;
        this.loginUsername = usernameParam
        this.currentUserSeen = usernameParam
      }
      else {
        this.currentUserSeen = this.up.name;
        this.loginUsername = this.up.name;
      }

      if (this.up != null) {
      }
      let modeSet: any = localStorage.getItem("mode");
      localStorage.removeItem("mode");
      if (null != modeSet && typeof modeSet != "undefined") {
        this.mode = <state>modeSet;
        if (usernameParam == 'create') {
          modeSet = 'createMode'
          this.mode = <state>modeSet;
          this.singleUserFrm.controls["firsttime"].setValue(true)
        }
      }
      else {
        if (usernameParam == 'create') {
          modeSet = 'createMode'
          this.mode = <state>modeSet;
          this.singleUserFrm.controls["firsttime"].setValue(true)
        }
        else if (usernameParam == 'clone') {
          modeSet = 'cloneMode'
          this.mode = <state>modeSet;
          this.singleUserFrm.controls["firsttime"].setValue(true)
        }
        else {
          modeSet = 'editMode'
          this.mode = <state>modeSet;
        }
      }

      this.company = this.up.currentCompany;
      this.permissionsService.hasPermission(["SUPERADMIN", "CONTROLPANELADMIN"])
        .then((result) => {
          if (!result) {
            this.getSingleUser();
          }
          else {
            this.UserService.getVisibleACLTabs(this.company).subscribe(
              result => {
                this.tabsArray = result;
                this.checkTabPermissions();
              },
              error => {
                console.log(error);
                console.log("There was an error getting the list of available tabs. Please try again or contact an admin.")
              }
            )
            if ((this.mode.toString() == "createMode" || this.mode.toString() == "cloneMode") && this.allCompanyUsers.length == 0) {
              this.getAllCompanyUsers();
            }

            if (this.mode.toString() != 'createMode') {
              let val: any = localStorage.getItem("userMngProfile");
              if (null != val && typeof val != "undefined") {
                this.getSingleUser();
                if (this.mode == 2 || this.mode.toString() == 'cloneMode') {
                  this.prepareClearUser();
                  this.singleUserFrm.controls["firsttime"].setValue(true);
                  this.singleUserFrm.controls["fullname"].setValue("");
                  this.singleUserFrm.controls["username"].setValue("");
                  this.singleUserFrm.controls["email"].setValue("");
                }
                this.isLoading = false;
              }
              else {
                this.getSingleUser();
              }

            }
            else {
              this.prepareClearUser();
              this.getCompanyGroups();
              this.isLoading = false;
            }

          }
        });
    }
    this.showManuelReset();
    this.showFirstTimeFunc();
    this.passwordType = "password";
    this.isLoading = false;
  }

  ngOnDestroy() {
    this.permissionsService.removePermission("ExpenditureFields");
    this.permissionsService.removePermission("WellsReport");
    this.permissionsService.removePermission("FieldsTree");
    this.permissionsService.removePermission("ReportsTree");
    this._routerSub.unsubscribe();
  }

  checkTabPermissions() {
    this.tabsArray.forEach(perm => {
      switch (perm) {
        case "ExpenditureFields":
          this.permissionsService.addPermission("ExpenditureFields");
          break;
        case "WellsReport":
          this.permissionsService.addPermission("WellsReport");
          break;
        case "ReportsTree":
          this.permissionsService.addPermission("ReportsTree");
          break;
        case "FieldsTree":
          this.permissionsService.addPermission("FieldsTree");
          break;

      }
    })
  }

  hasChangedTrue() {
    this.hasChanges = true;
  }

  hasChangedFalse() {
    this.hasChanges = false;
  }

  setHasCPAccess(access:boolean) {
    if (access) {
      this.hasCPAccess = true
    }
    else {
      this.hasCPAccess = false
    }
  }

  setButtonTitle() {
    if (this.sharedFunction.checkIE()) {
      let button = document.getElementById("CreateSubmitButton");
      if (null != button) {
        button.title = this.createUserMessage;
      }

    }

  }

  emailValidator(control: any) {
    if (control.value) {
      const matches = control.value.match(/[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?\.)+[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?/);
      return (matches && control.value.indexOf(" ") == -1) ? null : { 'invalidEmail': true };
    } else {
      return null;
    }
  }

  usernameValidator(control: any) {
    if (control.value) {
      let username: string = String(control.value);
      return (username.trim().toLowerCase() != 'create') ? null : { 'invalidString': true };
    } else {
      return null;
    }
  }

  passwordValidator(control: any) {
    if (!control.value) {
      return null;
    }
    else {
      if (this.mode != 0 && this.mode.toString() != 'editMode') {
        const matches = control.value.match('(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*(),.?":{}|<>]).{8,}');
        return (matches && control.value.indexOf(" ") == -1) ? null : { 'invalidEmail': true };
      }
      else {
        return null;
      }
    }
  }

  submitDisable() {
    let disable: boolean = true;

    if (this.singleUserFrm.controls['fullname'].dirty && (this.singleUserFrm.controls['fullname'].value != this.userProfile.fullname)) {
      disable = false;
    }
    else if (this.singleUserFrm.controls['email'].dirty && (this.singleUserFrm.controls['email'].value != this.userProfile.email)) {
      disable = false;
    }
    else if (this.singleUserFrm.controls['comment'].dirty && (this.singleUserFrm.controls['comment'].value != this.userProfile.comment)) {
      disable = false;
    }
    else if (this.singleUserFrm.controls['firsttime'].dirty && (this.singleUserFrm.controls['firsttime'].value != this.userProfile.firstTime)) {
      disable = false;
    }
    else if (this.singleUserFrm.controls['hasPortalAccess'].dirty && (this.singleUserFrm.controls['hasPortalAccess'].value != this.userProfile.hasPortalAccess)) {
      disable = false;
    }
    else if (this.singleUserFrm.controls['isApproved'].dirty && (this.singleUserFrm.controls['isApproved'].value != this.userProfile.isApproved)) {
      disable = false;
    }

    (disable? this.hasChangedFalse() : this.hasChangedTrue());

    return disable;
  }

  submitDisableCreate() {
    let pass = this.singleUserFrm.get('password');
    let confirm = this.singleUserFrm.get('rePassword');
    let check = false;
    this.createUserMessage = "Please make sure to ";
     if (this.ownedCompanyGroups.length <= 0) {
      this.createUserMessage = String().concat(this.createUserMessage, "select at least one group for the user to be in ")     
      check = true;
    }
    if (!this.singleUserFrm.controls['fullname'].dirty || this.singleUserFrm.controls['fullname'].value == this.userProfile.fullname || this.singleUserFrm.controls['fullname'].value == "") {
      if (this.createUserMessage.indexOf("select at least one group for the user to be in ") != -1) {
         this.createUserMessage = String().concat(this.createUserMessage, "and ")
       }
      if (this.createUserMessage.indexOf("fill out all required fields in the profile page ") == -1) {
        this.createUserMessage = String().concat(this.createUserMessage, "fill out all required fields in the profile page ")
      }
      check =  true;
    }
    else if (!this.singleUserFrm.controls['email'].dirty || this.singleUserFrm.controls['email'].value == this.userProfile.email || this.singleUserFrm.controls['email'].value == "") {
      if (this.createUserMessage.indexOf("select at least one group for the user to be in ") != -1) {
         this.createUserMessage = String().concat(this.createUserMessage, "and ")
       }
      if (this.createUserMessage.indexOf("fill out all required fields in the profile page ") == -1) {
        this.createUserMessage = String().concat(this.createUserMessage, "fill out all required fields in the profile page ")
      }
      check =  true;
    }
    else if (!this.singleUserFrm.controls['username'].dirty || this.singleUserFrm.controls['username'].value == this.userProfile.username || this.singleUserFrm.controls['username'].value == "") {
      if (this.createUserMessage.indexOf("select at least one group for the user to be in ") != -1) {
         this.createUserMessage = String().concat(this.createUserMessage, "and ")
       }
      if (this.createUserMessage.indexOf("fill out all required fields in the profile page ") == -1) {
        this.createUserMessage = String().concat(this.createUserMessage, "fill out all required fields in the profile page ")
      }
      check =  true;
    }
    else if (null != pass && null != confirm) {
      if (pass.value !== confirm.value) {
        if (this.createUserMessage.indexOf("select at least one group for the user to be in ") != -1) {
          this.createUserMessage = String().concat(this.createUserMessage, "and ")
        }
        if (this.createUserMessage.indexOf("fill out all required fields in the profile page ") == -1) {
          this.createUserMessage = String().concat(this.createUserMessage, "fill out all required fields in the profile page ")
        }
        check =  true;
      }
    }

    if (!check) {
      this.createUserMessage = "";
    }
    this.setButtonTitle();
    return check;
  }

  getSingleUser() {

    this.UserService.getSingleUser(this.currentUserSeen, this.company)
      .toPromise().then(result => {
        if (typeof result != "string") {
          this.userProfile = result;
         
          this.userProfile.email = this.userProfile.email.trim();
          this.userProfile2 = Object.assign({}, this.userProfile);
          this.setHasCPAccess(this.userProfile.hasPortalAccess);
          this.patchFormValues();
          this.getCompanyGroups();
          this.showManuelReset();
          this.showFirstTimeFunc();
          this.isLoading = false;
          if (this.mode == 2 || this.mode.toString() == 'cloneMode') {
            this.cloneUserName = this.userProfile.username;
            this.prepareClearUser();
          }
        }
      },
        error => {
          console.log(error);
          this.isLoading = false;
        })
  }

  prepareClearUser() {
    this.singleUserFrm.patchValue({
      'email': "",
      'fullname': "",
      'passwordAnswer': "",
      'passwordQuestion': "",
      'comment': "",
      'username': "",
      'password': "",
      'rePassword': ""
    });
    this.userProfile.comment = "";
    this.userProfile.creationDate = new Date();
    this.userProfile.email = "";
    this.userProfile.firstTime = true;
    this.userProfile.fullname = "";
 
    this.userProfile.lastActivityDate = new Date();
    this.userProfile.lastLoginDate = new Date();
    this.userProfile.lastPasswordChangedDate = new Date();
    this.userProfile.passwordAnswer = "";
    this.userProfile.passwordQuestion = "";
    this.userProfile.username = "";

  }

  getCompanyGroups() {
    this.groupLoading = true;
    
    this.UserService.getCompanyGroups().toPromise().then(
      result => {

        if (typeof result != "string") {
          localStorage.setItem("companyGroups", JSON.stringify(result));
          let grp: any = JSON.stringify(result)
          this.avaCompanyGroups = JSON.parse(grp) as avaCompanyGroups[];
          this.sortArrayObjAva.groupName = true;
          this.sortArrayObjOwned.groupName = true;
          this.orderList('groupName', 'ga');
          if (this.mode.toString() == 'createMode') {
            this.groupCheck();
          }
          else {
            this.getSingleUserGroupCheckList();
          }
        }
      },
      (error: string) => {
        this.groupLoading = false;
        console.log(error)
      });
  }

  getSingleUserGroupCheckList() {
    this.UserService.singleUserGroupCheckList(this.company, this.userProfile.username || this.cloneUserName)
      .subscribe(result => {
        if (typeof result != 'string') {
          this.groupsAlreadyAssoc = <avaCompanyGroups[]>result;
          
          this.groupCheck();
        }
      }, error => {
        this.groupLoading = false;
        console.log(error);
      });
  }

  modalLostFocus(divName: string, form: any) {
    let element = document.getElementById(divName);
    if (element != null) {
      if (element.style.display == "none") {
        if (divName == 'passwordmodal') {
          this.passwordModalChild.modalLostFocus()
        } else {
          this.resetForm(divName, form);
        }
      }
    }
  }

  resetForm(divName: string, form: any) {
    form.reset();
    switch (divName) {
      case "passwordmodal":
        this.manualPasswordAlertClass = "alert";
        this.manualPasswordReset = "";
        break;

      default:
        break;
    }
  }


  returnUsername() {
    return this.userProfile2;
  }

  resetpasswordmanual(form: any) {
    this.submitted = true;
    let username = this.userProfile.username;
    let input = form.value;
    if (input["password"] === input["repeat-password"]) {
      this.UserService.setUserPasswordReset(username, input["password"], false)
        .subscribe(result => {
          this.submitted = false;
          this.manualPasswordAlertClass = "alert alert-success"
          this.manualPasswordReset = result
        },
          error => {
            this.submitted = false;
            this.manualPasswordAlertClass = "alert alert-danger"
            this.manualPasswordReset = error
          })
    }
    else {
      this.submitted = false;
      this.manualPasswordAlertClass = "alert alert-danger"
      this.manualPasswordReset = "Please make sure both passwords match."

    }

  }


  groupCheck() {
    this.ownedCompanyGroups = this.groupsAlreadyAssoc;
    try { 
    this.avaCompanyGroups.forEach((item) => {
      item.lockIcon = "fas fa-plus";
    });

    if (this.ownedCompanyGroups.length == 0) {

    }
    else {
      this.orderList('groupName', 'go');
      for (let i = 0; i < this.avaCompanyGroups.length; i++) {
        this.ownedCompanyGroups.forEach((item) => {
          item.lockIcon = "fas fa-minus";
          if (this.avaCompanyGroups[i].groupID == item.groupID && this.avaCompanyGroups[i].groupName == item.groupName) {
            this.avaCompanyGroups.splice(i, 1)
            --i;
            if (i < 0) { i = 0; }
          }
          else {
            this.avaCompanyGroups[i].lockIcon = "fas fa-plus";

          }
        });
      };
      }
    } catch (ex) {
      console.log(ex);
    }
    this.groupLoading = false;
  }

  patchFormValues() {
    if (null == this.userProfile.firstTime) { this.userProfile.firstTime = false; }
    this.singleUserFrm.patchValue({
      'fullname': String(this.userProfile.fullname).trim(),
      'username': "",
      'email': String(this.userProfile.email).trim(),
      'passwordQuestion': String(this.userProfile.passwordQuestion).trim(),
      'passwordAnswer': String(this.userProfile.passwordAnswer).trim(),
      'comment': String(this.userProfile.comment).trim(),
      'password': "",
      'rePassword': "",
      'hasPortalAccess': this.userProfile.hasPortalAccess,
      'isApproved': this.userProfile.isApproved
    });
  }

  trimProfileValues() {
    let User = Object.assign({}, this.singleUserFrm.value);
    User.fullname = String(this.singleUserFrm.value.fullname).trim();
    User.username = String(this.singleUserFrm.value.username).trim();
    User.email = String(this.singleUserFrm.value.email).trim();
    User.passwordQuestion = String(this.singleUserFrm.value.passwordQuestion).trim();
    User.passwordAnswer = String(this.singleUserFrm.value.passwordAnswer).trim();
    User.comment = String(this.singleUserFrm.value.comment).trim();
    return User;
  }

  createUser() {
    let createUserObj: any;
    this.submitted = true;
    let reportIDs: any;
    let fieldIDs: any;
    let wellIDs: any;
    let fieldExpendituresIDs: any;
    if (this.tabsArray.includes("ReportsTree") ? reportIDs = this.getReportIDs() : reportIDs = [])
    if (this.tabsArray.includes("FieldsTree") ? fieldIDs = this.getFieldIDs() : fieldIDs = [])
      if (this.tabsArray.includes("WellsReport") ? wellIDs = this.getWellIDs() : wellIDs = [])
    if (this.tabsArray.includes("ExpenditureFields") ? fieldExpendituresIDs = this.getFieldExpendituresIDs() : fieldExpendituresIDs = [])
  

    this.profileMessage = "";
    let addObj = <UserGroup[]>this.ownedCompanyGroups;

    createUserObj = {
      "userInfo": this.trimProfileValues(), "groups": addObj, "password": String(this.singleUserFrm.controls['password'].value).trim(), "company": this.company, "reportsForACL": reportIDs,
      "fieldIDsForACL": fieldIDs, "wellIDsForACL": wellIDs, "expenditureFieldIDsForACL": fieldExpendituresIDs};
    delete createUserObj.userInfo.rePassword;
    this.UserService.addUser2(createUserObj, this.company, this.singleUserFrm.controls['password'].value)
      .subscribe(result => {
        if (result) {
          this.userProfile = result.userInfo        
          this.userProfile2 = Object.assign({}, this.userProfile);        
          alert("New user " + this.userProfile2.username + " was successfully created.")
          this.showManuelReset();
          this.showFirstTimeFunc();
          if (this.tabsArray.includes("ReportsTree")) {this.refreshReportsACLChild(); }
          if (this.tabsArray.includes("FieldsTree")) {this.refreshFieldsACLChild(); }
          if (this.tabsArray.includes("WellsReport")) {this.refreshWellsACLChild(); }
          if (this.tabsArray.includes("ExpenditureFields")) {this.refreshFieldsExpendituresACLChild(); }
                    
        }
        this.mode = state.editMode;
        this.submitted = false;
        this.hasChanges = false;
      },
        error => {
          this.submitted = false;
          this.saveChangesAlertClass = "alert alert-danger";
          this.profileMessage = error;
          console.log(error);
        })
  }

  saveSingleUserProfileChanges(form: any) {
    this.submitted = true;
    let newObj = this.checkFormSubmitEdit();

    this.UserService.singleUserProfileUpdate(newObj, this.company)
      .subscribe(result => {

        this.profileMessage = result;
        this.updateUserProfile();
        this.saveChangesAlertClass = "alert alert-success"
        this.singleUserFrm.markAsPristine();
        this.hasChanges = false;
        this.submitted = false;
      },
        error => {
          this.profileMessage = error;
          this.saveChangesAlertClass = "alert alert-danger"
          this.submitted = false;
        });
  }

  checkFormSubmitEdit() {
    let newObj = Object.assign({}, this.userProfile);
    if (this.singleUserFrm.controls['fullname'].dirty && this.singleUserFrm.controls['fullname'].value.trim() != newObj.fullname.trim()) {
      newObj.fullname = String(this.singleUserFrm.controls['fullname'].value).trim();
    }
    if (this.singleUserFrm.controls['email'].dirty && this.singleUserFrm.controls['email'].value.trim() != newObj.email.trim()) {
      newObj.email = String(this.singleUserFrm.controls['email'].value).trim();
    }
    if (this.singleUserFrm.controls['passwordQuestion'].dirty && this.singleUserFrm.controls['passwordQuestion'].value.trim() != newObj.passwordQuestion.trim()) {
      newObj.passwordQuestion = String(this.singleUserFrm.controls['passwordQuestion'].value).trim();
    }
    if (this.singleUserFrm.controls['passwordAnswer'].dirty && this.singleUserFrm.controls['passwordAnswer'].value.trim() != newObj.passwordAnswer.trim()) {
      newObj.passwordAnswer = String(this.singleUserFrm.controls['passwordAnswer'].value).trim();
    }
    if (this.singleUserFrm.controls['comment'].dirty && this.singleUserFrm.controls['comment'].value.trim() != newObj.comment.trim()) {
      newObj.comment = String(this.singleUserFrm.controls['comment'].value).trim();
    }
    if (this.singleUserFrm.controls['firsttime'].dirty && this.singleUserFrm.controls['firsttime'].value != newObj.firstTime) {
      newObj.firstTime = this.singleUserFrm.controls['firsttime'].value
    }
    newObj.hasPortalAccess = this.singleUserFrm.controls['hasPortalAccess'].value;
    newObj.isApproved = this.singleUserFrm.controls['isApproved'].value;
    return newObj;
  }

  toggleCheckClicked(e: Event, id: string) {
    if (this.mode === state.editMode) {
      $("#" + id + "_spinner").show("slow");
      $("#" + id + "_spinner").hide("slow");
    }
    else {

    }
  }

  setUserProfile() {
    this.UserService.getSingleUser(this.singleUserFrm.controls['username'].value, this.company)
      .subscribe(result => {
          if (typeof result != "string") {
            this.userProfile = result;
          }
      }, error => {
          console.log(error);
          this.userProfile.fullname = String(this.singleUserFrm.controls['fullname'].value).trim();
          this.userProfile.username = String(this.singleUserFrm.controls['username'].value).trim();
          this.userProfile.email = String(this.singleUserFrm.controls['email'].value).trim();
          this.userProfile.passwordAnswer = String(this.singleUserFrm.controls['passwordAnswer'].value).trim();
          this.userProfile.passwordQuestion = String(this.singleUserFrm.controls['passwordQuestion'].value).trim();
          this.userProfile.hasPortalAccess = this.singleUserFrm.controls['hasPortalAccess'].value;
          this.userProfile.isApproved = this.singleUserFrm.controls['isApproved'].value;
      })
  }

  checkFormSubmitCreate() {
    let newObj = Object.assign({}, this.userProfile);
    if (this.singleUserFrm.controls['fullname'].dirty && this.singleUserFrm.controls['fullname'].value.trim() != newObj.fullname.trim()) {
      newObj.fullname = String(this.singleUserFrm.controls['fullname'].value).trim();
    }
    if (this.singleUserFrm.controls['email'].dirty && this.singleUserFrm.controls['email'].value.trim() != newObj.email.trim()) {
      newObj.email = String(this.singleUserFrm.controls['email'].value).trim();
    }
    if (this.singleUserFrm.controls['passwordQuestion'].dirty && this.singleUserFrm.controls['passwordQuestion'].value.trim() != newObj.passwordQuestion.trim()) {
      newObj.passwordQuestion = String(this.singleUserFrm.controls['passwordQuestion'].value).trim();
    }
    if (this.singleUserFrm.controls['passwordAnswer'].dirty && this.singleUserFrm.controls['passwordAnswer'].value.trim() != newObj.passwordAnswer.trim()) {
      newObj.passwordAnswer = String(this.singleUserFrm.controls['passwordAnswer'].value).trim();
    }
    if (this.singleUserFrm.controls['comment'].dirty && this.singleUserFrm.controls['comment'].value.trim() != newObj.comment.trim()) {
      newObj.comment = String(this.singleUserFrm.controls['comment'].value).trim();
    }
    if (this.singleUserFrm.controls['firsttime'].dirty && this.singleUserFrm.controls['firsttime'].value != newObj.firstTime) {
      newObj.firstTime = this.singleUserFrm.controls['firsttime'].value
    }

    newObj.hasPortalAccess = this.singleUserFrm.controls['hasPortalAccess'].value;
    newObj.isApproved = this.singleUserFrm.controls['isApproved'].value;

    return newObj;
  }

  checkDate(date: any) {
    
    if (null == date) {
      return "N/A";
    }
    else if (typeof date == 'string') {
      let d: Date = new Date(date);
      let dateMin: string = String(d.getMinutes())
      let datehour: string = String(d.getHours())
      let time:string = "AM"
      if (d.getMinutes() < 10) {
        dateMin = "0" + String(d.getMinutes());
      }
      if (d.getHours() > 12) {
        datehour = String(d.getHours() - 12);
        
      }
      if (d.getHours() >= 12) {
        
        time = "PM";
      }
      
      return d.toDateString() + "  at " + datehour + ":" + dateMin + " " + time ;
    }
  }

  getGroupIndex(group: avaCompanyGroups, groupList: avaCompanyGroups[]): any {
    groupList.forEach((item, index) => {
      if (item.groupID == group.groupID && item.groupName == group.groupName) {
        groupList.splice(index, 1);
        return index;
      }
    })
  }

  changeGroupAssoc(group: avaCompanyGroups, value: boolean, index: number) {
    let groupAssociation: string = "";
    this.hasChangedTrue();
    if (this.mode == 0 || this.mode.toString() == "editMode") {
      this.groupActiveChangeCount = this.groupActiveChangeCount + 1;
      if (group.lockIcon != "spinner-border spinner-border-sm") {
        group.lockIcon = "spinner-border spinner-border-sm"
        if (value) { groupAssociation = "add"; }
    
        let test = this.UserService.userGroupAssociation({ "Usernames": [this.userProfile.username], "CompanyName": String(this.company), "GroupIDs": [group.groupID] }, String(this.company), groupAssociation)
          .subscribe(
            result => {

              if (value) {
                index = this.getGroupIndex(group, this.avaCompanyGroups);
                group.lockIcon = "fas fa-minus"

                this.ownedCompanyGroups.push(group);
              }
              else {
                index = this.getGroupIndex(group, this.ownedCompanyGroups);
                group.lockIcon = "fas fa-plus"

                this.avaCompanyGroups.push(group);
              }


              this.groupActiveChangeCount = this.groupActiveChangeCount - 1;
              if (this.groupActiveChangeCount == 0) {
                this.hasChanges = false;
                test.unsubscribe();
              }

            },
            error => {
              console.log(error);
              test.unsubscribe();
              this.groupActiveChangeCount = this.groupActiveChangeCount - 1;
              if (this.groupActiveChangeCount == 0) { this.hasChanges = false; }
              if (value) {
                group.lockIcon = "fas fa-plus"
              }
              else {
                group.lockIcon = "fas fa-minus"
              }
            })
      }
    }
    else {
      if (group.lockIcon == "fas fa-plus") {
        this.getGroupIndex(group, this.avaCompanyGroups);
        this.ownedCompanyGroups.push(group)
        group.lockIcon = "fas fa-minus"
      }
      else {
        this.getGroupIndex(group, this.ownedCompanyGroups);
        this.avaCompanyGroups.push(group)
        group.lockIcon = "fas fa-plus"
      }

    }
  }

  showPassword() {
    if (this.passwordType == "password") {
      this.passwordType = "text";
    }
    else {
      this.passwordType = "password";
    }
  }

  checkUserName(e:any) {
    let check: boolean;
    let pass: boolean = true;
    check = this.hasCPAccess ? true : false;
      if (null != this.loginUsername && check && this.userProfile.username.toLowerCase() == this.loginUsername.toLowerCase() && (this.mode == 0 || this.mode.toString() == 'editMode')) {
        if (!confirm("By turning this off, " + this.userProfile.username + " will be unable to access the Portal. Are you sure you want to continue?")) {
          e.preventDefault();
          if (check) {
            this.hasCPAccess = true
            this.singleUserFrm.patchValue({ 'hasPortalAccess': true });
          }
          else {
            this.hasCPAccess = false
            this.singleUserFrm.patchValue({ 'hasPortalAccess': false });
          }
          pass = false
        }
        else {
          pass = true;
        }
      }
    if (pass) {
      if (check) {
        this.hasCPAccess = false
      }
      else {
        this.hasCPAccess = true
      }
    }
  }

  showManuelReset() {
        
    if (this.up.isSuperAdmin) {
      if (this.mode.toString() == "createMode" || this.mode.toString() == "cloneMode") {
        this.showManualReset = false;
      } else {
        this.showManualReset = true;
      }
    } else {
      if (null != this.userProfile.username && (this.mode == 0 || this.mode.toString() == 'editMode') && this.up.name.toLowerCase() == this.userProfile.username.toLowerCase()) {
        this.showManualReset = true;
      } else {
        this.showManualReset = false;
      }
    }  
  }

  showFirstTimeFunc() {
    if ((this.mode != 0 && this.mode.toString() != 'editMode')) {
      this.showFirstTime = true;
    }
    else if (typeof this.loginUsername != 'undefined' && typeof this.userProfile.username != 'undefined') {
      if (String(this.loginUsername).toLowerCase() != String(this.userProfile.username).toLowerCase()) {
        this.showFirstTime = true;
      }
      else {
        this.showFirstTime = false;
      }
    }
  }

  updateUserProfile() {
    if (this.singleUserFrm.controls['fullname'].dirty && (this.singleUserFrm.controls['fullname'].value != this.userProfile.fullname)) {
      this.userProfile.fullname = String(this.singleUserFrm.controls['fullname'].value).trim();
    }
    else if (this.singleUserFrm.controls['email'].dirty && (this.singleUserFrm.controls['email'].value != this.userProfile.email)) {
      this.userProfile.email = String(this.singleUserFrm.controls['email'].value).trim();
    }
    else if (this.singleUserFrm.controls['passwordQuestion'].dirty && (this.singleUserFrm.controls['passwordQuestion'].value != this.userProfile.passwordQuestion)) {
      this.userProfile.passwordQuestion = String(this.singleUserFrm.controls['passwordQuestion'].value).trim();
    }
    else if (this.singleUserFrm.controls['passwordAnswer'].dirty && (this.singleUserFrm.controls['passwordAnswer'].value != this.userProfile.passwordAnswer)) {
      this.userProfile.passwordAnswer = String(this.singleUserFrm.controls['passwordAnswer'].value).trim();
    }
    else if (this.singleUserFrm.controls['comment'].dirty && (this.singleUserFrm.controls['comment'].value != this.userProfile.comment)) {
      this.userProfile.comment = String(this.singleUserFrm.controls['comment'].value).trim();
    }
    else if (this.singleUserFrm.controls['firsttime'].dirty && (this.singleUserFrm.controls['firsttime'].value != this.userProfile.firstTime)) {
      this.userProfile.firstTime = this.singleUserFrm.controls['firsttime'].value;
    }
    else if (this.singleUserFrm.controls['hasPortalAccess'].dirty && (this.singleUserFrm.controls['hasPortalAccess'].value != this.userProfile.hasPortalAccess)) {
      this.userProfile.hasPortalAccess = this.singleUserFrm.controls['hasPortalAccess'].value;
    }
    else if (this.singleUserFrm.controls['isApproved'].dirty && (this.singleUserFrm.controls['isApproved'].value != this.userProfile.isApproved)) {
      this.userProfile.isApproved = this.singleUserFrm.controls['isApproved'].value;
    }
    if (this.userProfile.hasPortalAccess ? this.hasCPAccess = true : this.hasCPAccess = false)
    this.userProfile2 = Object.assign({}, this.userProfile);
  }

  refreshWellsACLChild() {
    this.wellsACLChild.refresh();  //*commented out or init commit david
  }

  refreshFieldsACLChild() {
    this.fieldsACLChild.refresh();  //*commented out or init commit david
  }

  refreshReportsACLChild() {
    this.reportsACLChild.refresh();  //*commented out or init commit david
  }

  refreshFieldsExpendituresACLChild() {
    this.fieldExpendituresACLChild.refresh();  //*commented out or init commit david
  }

  refreshGroups() {
    if (this.mode == 0 || this.mode.toString() == 'editMode') {
      this.search = "";
      this.getCompanyGroups();
    }
  }

  getReportIDs() {
    let IDs = this.reportsACLChild.returnReportForCloneUser();
    let IDsReturn: Array<number> = []
    IDs.forEach((item) => {
      item.reportID.forEach((ids) => {
        IDsReturn.push(Number(ids));
      })
      
    })
    return IDsReturn;
  }

  getWellIDs() {
    let IDs = this.wellsACLChild.returnWellsForCloneUser();
    let IDsReturn: Array<number> = []
    IDs.forEach((item) => {
      IDsReturn.push(Number(item.wellID));
    })
    return IDsReturn;
  }

  getFieldIDs() {
    let IDs = this.fieldsACLChild.returnFieldsForCloneUser();
    let IDsReturn: Array<number> = []
    IDs.forEach((item) => {
      IDsReturn.push(Number(item.fieldID));
    })
    return IDsReturn;
  }

  getFieldExpendituresIDs() {
    let IDs = this.fieldExpendituresACLChild.returnFieldsForCloneUser();
    let IDsReturn: Array<number> = []
    IDs.forEach((item) => {
      IDsReturn.push(Number(item.fieldID));
    })
    return IDsReturn;
  }

  orderList(columnName: string, list: string) {
    if (list == 'ga') {
      this.sharedFunction.sortArray(this.avaCompanyGroups, columnName, this.sortArrayObjAva);
      if (this.sortArrayObjAva[columnName]) {
        this.sortArrayObjAva[columnName] = false;
      } else {
        this.sortArrayObjAva[columnName] = true;
      }
      this.dummbyValue1 = new Date();
    } else {
      this.sharedFunction.sortArray(this.ownedCompanyGroups, columnName, this.sortArrayObjOwned);
      if (this.sortArrayObjOwned[columnName]) {
        this.sortArrayObjOwned[columnName] = false;
      } else {
        this.sortArrayObjOwned[columnName] = true;
      }
      this.dummbyValue2 = new Date();
    }
  }

  getAllCompanyUsers() {
    this.loadingAllUsers = true;
    this.UserService.getUsersInCompany(this.company).subscribe(
      result => {
        if (typeof result != "string") {
          this.allCompanyUsers = result;
          for (let i = 0; i < this.allCompanyUsers.length; i++) {
            let option: SelectItem = {
              label: `${this.allCompanyUsers[i].username} | ${this.allCompanyUsers[i].fullname}`,
              value: `${this.allCompanyUsers[i].username}`
            }
            this.userSelectOptions.push(option);
          }
          this.loadingAllUsers = false;
        }
      },
      error => {
        console.log(error);
        this.loadingAllUsers = false;
      }
    );
  }

  cloneUser(mode: string, username: string) {
    this.mode = <state><unknown>mode;
    this.cloneUserName = username;
    this.userProfile2 = this.allCompanyUsers.find(user => user.username == username);
    this.userProfile2["isChecked"] = true;
    localStorage.setItem("mode", mode);
    localStorage.setItem("userMngProfile", JSON.stringify(this.userProfile2));

    let lastIndexOfSep = this.router.url.lastIndexOf('/') + 1
    this.prepareClearUser();

    this.router.navigate([this.router.url.substring(0, lastIndexOfSep) + username]);
  }
}

export enum state {
  cloneMode = 2,
  createMode = 1,
  editMode = 0
}

interface avaCompanyGroups extends UserGroup {
  lockIcon: string;
}

interface UserGroup {
  groupID: number;
  groupName: string;
}
